import React from 'react'

export interface WidgetContainerContextTypes {
  children: React.ReactNode
  availableHeight: number
  availableWidth: number
}
export const WidgetContainerContext = React.createContext<WidgetContainerContextTypes | null>(null)

export const WidgetContainerProvider: React.FC<
  React.PropsWithChildren<WidgetContainerContextTypes>
> = ({ children, availableHeight, availableWidth }) => {
  return (
    <WidgetContainerContext.Provider
      value={{
        availableHeight,
        availableWidth,
        children,
      }}
    >
      {children}
    </WidgetContainerContext.Provider>
  )
}
